import { render, staticRenderFns } from "./UploadDeposit.vue?vue&type=template&id=3db2aea6&scoped=true"
import script from "./UploadDeposit.vue?vue&type=script&lang=js"
export * from "./UploadDeposit.vue?vue&type=script&lang=js"
import style0 from "./UploadDeposit.vue?vue&type=style&index=0&id=3db2aea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db2aea6",
  null
  
)

export default component.exports